import { Language } from "@types";

export const STORAGE_KEY = {
  ACCESS_TOKEN: "token",
  //only remember phone while onboard
  //if switch tab the onboarding phone is still be passed to login/register component
  ONBOARDING_PHONE: "onboarding-phone",
  LANGUAGE: "lng",
  MODE: "mode",
  OTP_TIMEOUT_PREFIX: "pk-",
  MARKETING_DATA: "mktg-data",
  REF_CODE: "ref-code",
  APP_UPDATE_AVAILABLE: "app-update-available",
  LOGIN_METHOD: "login-method",
  LOGIN_CRED_ID: "login-id",
  LOGIN_CRED_SECRET: "login-secret",
  LOGIN_PHONE: "login-phone",
  MEMBER_SETTINGS: "member-settings",
} as const;

export const LANGUAGES = [
  {
    code: Language.EN,
    name: "English",
    flagURL: "/images/flags/flag-gb.svg",
  },
  {
    code: Language.TH,
    name: "ภาษาไทย",
    flagURL: "/images/flags/flag-th.svg",
  },
  {
    code: Language.ID,
    name: "Bahasa",
    flagURL: "/images/flags/flag-id.svg",
  },
  {
    code: Language.BN,
    name: "বাংলা",
    flagURL: "/images/flags/flag-bd.svg",
  },
  {
    code: Language.UR,
    name: "اردو",
    flagURL: "/images/flags/flag-pk.svg",
  },
];

export enum OnboardMode {
  LOGIN = "login",
  REGISTER = "register",
}

export const ACCESS_TOKEN_ENDPOINT = "/oauth/access_token";

export const DEFAULT_ERROR_MESSAGE = "an error occurred, please try again";

export const DEFAULT_CONNECTION_ERROR_MESSAGE = "something went wrong. please try again.";
